import {
  FaPhone,
  FaPhoneSlash,
  FaComment,
  FaCommentAlt,
  FaQuestion,
  FaExclamation,
  FaVoicemail,
} from "react-icons/fa";
import {
  getSessionDisplayStatus,
  SESSION_DISPLAY_STATUS,
} from "./sessionDisplayStatus";

export const renderCallStatusIcon = (header) => {
  const call_status = header.voice_statistic?.final_call_status?.replace(
    "-",
    " ",
  );

  const iconConfig = {
    voice: {
      voicemailReached: {
        group: true,
        icons: [
          {
            Icon: FaPhoneSlash,
            color: "red",
            title: call_status,
          },
          {
            Icon: FaVoicemail,
            color: "green",
            title: "Voicemail left",
            size: "xs",
          },
        ],
      },
      callConducted: {
        Icon: FaPhone,
        color: "green",
        title: call_status,
      },
      callOngoing: {
        Icon: FaPhone,
        color: "blue",
        title: call_status ? call_status : "Call Ongoing",
      },
      callFailed: {
        group: true,
        icons: [
          {
            Icon: FaPhoneSlash,
            color: "red",
            title: call_status,
          },
          {
            Icon: FaVoicemail,
            color: "red",
            title: "Failed to Leave Voicemail",
            size: "xs",
          },
        ],
      },
    },
    text: {
      open: {
        Icon: FaComment,
        color: "blue",
        title: "Texting ongoing",
      },
      complete: {
        Icon: FaComment,
        color: "green",
        title: "Texting completed successfully",
      },
      neutral: {
        Icon: FaComment,
        color: "gray",
        title: "Patient opted out",
      },
      failed: {
        group: true,
        icons: [
          {
            Icon: FaComment,
            color: "red",
            title: "Error occured while sending text messages",
          },
          { Icon: FaExclamation, color: "red", title: "Failed message" },
        ],
      },
    },
    chat: {
      default: {
        Icon: FaCommentAlt,
        color: "purple",
        title: "Chat UI session",
      },
    },
    default: {
      Icon: FaQuestion,
      color: "gray",
      title: "Unknown modality",
    },
  };

  const iconConfigByStatus = {
    [SESSION_DISPLAY_STATUS.VOICE_ONGOING]: iconConfig.voice.callOngoing,
    [SESSION_DISPLAY_STATUS.VOICE_VOICEMAIL_LEFT]:
      iconConfig.voice.voicemailReached,
    [SESSION_DISPLAY_STATUS.VOICE_COMPLETED]: iconConfig.voice.callConducted,
    [SESSION_DISPLAY_STATUS.VOICE_FAILED]: iconConfig.voice.callFailed,
    [SESSION_DISPLAY_STATUS.TEXT_ONGOING]: iconConfig.text.open,
    [SESSION_DISPLAY_STATUS.TEXT_COMPLETED]: iconConfig.text.complete,
    [SESSION_DISPLAY_STATUS.TEXT_FAILED]: iconConfig.text.failed,
    [SESSION_DISPLAY_STATUS.CHAT]: iconConfig.chat.default,
    [SESSION_DISPLAY_STATUS.UNKNOWN]: iconConfig.default,
  };
  const config = iconConfigByStatus[getSessionDisplayStatus(header)];

  if (config.group) {
    return (
      <div className="flex items-center">
        {config.icons.map((iconCfg, index) => {
          const { Icon, color, title, size = "sm" } = iconCfg;
          const titleValue =
            typeof title === "function" ? title(header) : title;
          return (
            <Icon
              key={index}
              className={`text-${color}-500 text-${size} ${
                index > 0 ? "ml-1" : ""
              }`}
              title={titleValue}
            />
          );
        })}
      </div>
    );
  }

  const { Icon, color, title, size = "sm" } = config;
  return <Icon className={`text-${color}-500 text-${size}`} title={title} />;
};
